module.exports = __webpack_public_path__ + "img/homescreen-min.0e6a80de.png";